import { Component,  OnInit,   ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { AgendaService } from 'src/app/services/agenda.service';
import { AlertComponent } from '../../alert/alert.component';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/services/loader.service';
@Component({
  selector: 'app-agenda-group',
  templateUrl: './agenda-group.component.html',
  styleUrls: ['./agenda-group.component.css']
})
export class AgendaGroupComponent implements OnInit {

  public environmentSettings: any;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger: Subject<any> = new Subject();
  indexGroupingList: any;
  GroupingIndex: any;
  GroupingName: any;
  GroupingNumber: any;
  addBtn: any;
  editGroupId: any;
  disabledOnclick: boolean; 
  GroupingNumberTouched: boolean; 
  GroupingNameTouched: boolean;
  GroupingIndexTouched: boolean;
  IsGlobal: boolean;
  constructor(private agendaService: AgendaService,
    private alert: AlertComponent,
    private loaderService: LoaderService) { }

  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }

  ngOnInit() {
    this.environmentSettings = environment;
    
    this.addBtn = true;
    this.dtOptions = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers', 
      paging: true,
      pageLength: 10,
      search: true,
      order: [1, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [2] }],
      dom: 'lBfrtip',//'Bfrtip',
      // Configure the buttons
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Agenda Group List',
          title: 'Agenda Group List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
        }

        }
      ]
    };
    this.getGroupIndex();
  }

  noBlankSpaceAtStart(ev) {
    if (ev.which === 32 && ev.target.selectionStart === 0) {
      return false;
    }
  }

  showAddPopUp() {
    this.GroupingIndex = undefined;
    this.GroupingName = "";
    this.GroupingNumber = "";
    this.GroupingNumberTouched = false;
    this.GroupingNameTouched = false;
    this.GroupingIndexTouched = false;
    this.addBtn = true;
    $('#GlobalGroup').prop("disabled", false);
    $('#CompanyGroup').prop("disabled", false);
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#indexGrouping').removeClass('show').hide();
  
    setTimeout(() => {
      $('#indexGrouping').modal('show');
    }, 100);
  }

  SaveIndexGrouping() {
    this.disabledOnclick = true;
    console.log('oooo0000', this.GroupingIndex,
      this.GroupingName, this.GroupingNumber
    )
    var IsGlobal;
    if (this.GroupingIndex == 'GlobalGroup') {
      IsGlobal = true;
    } else {
      IsGlobal = false;
    }

    var data = {
      'IsGlobal': IsGlobal,
      'GroupingName': this.GroupingName,
      'GroupingNumber': this.GroupingNumber
    }

    this.agendaService.addGroupIndex(data).subscribe(data => {
      this.disabledOnclick = false;
      if (data.status == 0) {
        $("#indexGrouping .close").click();
        // this.getGroupIndex();
        this.GroupingIndex = undefined;
        this.GroupingName = undefined;
        this.GroupingNumber = undefined;
        this.alert.success('Group added successfully')
        $("#groupTable").DataTable().destroy();
      } else {
         if (data.error.name == "ValidationError") {
          this.alert.error(data.error.message);
            }else{
              this.alert.error('something went wrong.');
            }
      }
      console.log('data', data);
      this.getGroupIndex();
    });
    $('#indexGrouping').off('hidden.bs.modal');   
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#indexGrouping').modal('hide');
  }

  getGroupIndex() {
    this.indexGroupingList = [];
    $("#groupTable").DataTable().destroy();
    this.agendaService.getGroupIndex().subscribe(data => {
      if (data.status == 0) {
        this.indexGroupingList = data.data;
        this.dtTrigger.next();
      }
    });
  }

  setGroupingType(typeOfGroup) {
    console.log('typeOfGroup', typeOfGroup)
    this.GroupingIndex = typeOfGroup;
  }

  getGroupIndexById(groupId) {
    this.loaderService.disable();
    this.editGroupId = groupId;
    this.agendaService.getGroupIndexById(groupId).subscribe(data => {
      if (data.status == 0) {
        this.GroupingNumber = data.data[0].GroupingNumber;
        this.GroupingName = data.data[0].GroupName;
        if (data.data[0].IsGlobal == true) {
          this.GroupingIndex = 'GlobalGroup';
        } else {
          this.GroupingIndex = 'CompanyGroup';
        }
        this.IsGlobal = data.data[0].IsGlobal;
        this.addBtn = false;
        $('#GlobalGroup').prop("disabled", true);
        $('#CompanyGroup').prop("disabled", true);
        $('#indexGrouping').modal('toggle');
      }
    });
  }

  updateIndexGrouping() {
    this.disabledOnclick = true;
    // var IsGlobal;
    // if (this.GroupingIndex == 'GlobalGroup') {
    //   IsGlobal = true;
    // } else {
    //   IsGlobal = false;
    // }

    var data = {
      'IsGlobal': this.IsGlobal,
      'GroupingName': this.GroupingName,
      'GroupingNumber': this.GroupingNumber,
      'groupId': this.editGroupId
    }

    this.agendaService.updateGroupIndex(data).subscribe(data => {
      this.disabledOnclick = false;
      if (data.status == 0) {
        $("#indexGrouping .close").click();
        this.GroupingIndex = undefined;
        this.GroupingName = undefined;
        this.GroupingNumber = undefined;
        this.alert.success('Group updated successfully');
        $("#groupTable").DataTable().destroy();
      } else {
        if (data.message.name == "ValidationError") {
          this.alert.error(data.message.message);
            }else{
              this.alert.error('something went wrong.');
            }
        
      }
      this.getGroupIndex();
      console.log('data', data)
    });
  }

  deleteConfirmation(groupId) {
    this.editGroupId = groupId;
    $('#confirmation').modal('toggle');
  }

  deleteAgendaGroup() {
  
      this.agendaService.deleteAgendaGroup(this.editGroupId).subscribe(data => {
        if (data.status == 0) {
          this.getGroupIndex();
          $('#confirmation').modal('toggle');
          this.alert.success("Agenda Group deleted successfully");
          $("#groupTable").DataTable().destroy();
        }
        else {
          $('#confirmation').modal('toggle');
          this.alert.error(data.message);
        }
      });
    
  }

  groupingNumberFieldTouched(){
    this.GroupingNumberTouched = true;
  }

  groupingNameFieldTouched(){
    this.GroupingNameTouched = true;
  }

}
